module.exports = __webpack_public_path__ + "img/53.a59af82b.gif";